var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toggle-button',{staticClass:"mb-0",attrs:{"width":35,"height":20,"value":_vm.hasLeaderboard(),"sync":true,"color":{checked: '#348EF6', unchecked: '#D3D7E1'}},on:{"change":function($event){return _vm.handleToggleLeaderboard()}}})}
var staticRenderFns = []

export { render, staticRenderFns }